import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";
import { motion, AnimatePresence } from "framer-motion";

const LINKS = [
  { to: "/licensing", label: "Licensing" },
  { to: "/recruitment", label: "Recruitment" },
  { to: "/consulting", label: "Consulting" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function SiteNav() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header data-testid="site-nav" className="fixed inset-x-0 top-0 z-50 border-b border-brand-gold/15 bg-brand-night/85 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 sm:px-8 h-20">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center group" onClick={() => setOpen(false)}>
          <img src="/mayfair-logo.webp" alt="Mayfair Medical Services" className="h-14 w-auto object-contain rounded-sm" />
        </Link>

        <nav className="hidden lg:flex items-center gap-9" data-testid="nav-links">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors duration-300 hover:text-brand-gold ${
                  isActive ? "text-brand-gold" : "text-brand-bone/75"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-cta-button"
            className="rounded-full bg-brand-gold px-6 py-2.5 text-sm font-semibold text-brand-night transition-all duration-300 hover:bg-brand-goldlight hover:-translate-y-0.5"
          >
            Start Enquiry
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-brand-bone p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <List size={26} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            key={location.pathname}
            data-testid="nav-mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="lg:hidden overflow-hidden border-t border-brand-gold/15 bg-brand-night/95 backdrop-blur-xl"
          >
            <div className="flex flex-col px-6 py-6 gap-5">
              {LINKS.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `font-serif text-2xl ${isActive ? "text-brand-gold" : "text-brand-bone/85"}`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
